// 通知栏
import "./index.less";
import { getServerTime } from '@utils/api.js'
import { countTime } from '@utils/index'
$(document).ready(function () {
  if (!customElements.get("jky-announment-bar")) {
    customElements.define(
      "jky-announment-bar",
      class JkyAnnounmentBar extends HTMLElement {
        constructor() {
          super();
          // 数据
          this.announceContent = JSON.parse(document.querySelector('#announcement-bar').innerText)
          this.selectors = {
            announce_close: $(this).find(".announce-bar .announce-bar--close"),
            announce_bar: $(this).find(".announce-bar"),
            announce_swiper_container: $(this).find(
              ".swiper-wrapper-container"
            ),
            announce_swiper_slide: $(this).find(".announce-swiper-slide"),
            announce_count_down: $(this).find(".announce-swiper-slide .countdown"),
          };
          this.serverTime = 0 // 服务器时间
          this.speed = $(this).data('speed')
          this.init()
        }
        isMobile() {
          return window.matchMedia("(max-width: 1024px)").matches;
        }
        // 获取服务器时间
        async getTime() {
          const {data} = await getServerTime();
          this.serverTime = new Date(data.datetime).getTime();
        }
        // 初始化Announcebar
        async initAnnouncebar() {
          const that = this
          // 过滤符合条件的数据
          // 1、开始时间和结束时间必须要配置
          // 2、开始时间小于当前服务器时间并且结束时间大于当前服务器时间
          // 2、是否显示倒计时UI以show_count_down为主，如果有则显示
          const filterBars = this.announceContent.length > 0 && this.announceContent.filter(item => item.begin_time && item.end_time)
                                    .filter(item => new Date(item.begin_time).getTime() <= this.serverTime && new Date(item.end_time).getTime() > this.serverTime);
          // 如果大于0 则显示bar
          if (filterBars.length === 0) {
            return false
          }
          this.selectors.announce_bar.addClass('announce-bar-show')

          let html = ''
          filterBars.forEach((item, index) => {
            let style = ''
            if (item.type == 1) {
              style = `background: ${item.bg_color};`
            } else {
              const backgroundImage = that.isMobile() ? item.bg_mb_image : item.bg_pc_image;
              style = `background-image: url(${backgroundImage});`
            }
            const barText = that.isMobile() ? (item.text_mb || item.text) : item.text;
            const textHtml = item.text ? `
                <div class="announce-item-text" style="color: ${item.text_color}">${barText}</div>
                <div class="announce-item-arrow">
                  <svg
                    class="svg-arrow-line"
                    style="display: none"
                    fill="${item.arrow_color}"
                    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4247"><path d="M885.113 489.373L628.338 232.599c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255l203.3 203.3H158.025c-17.036 0-30.846 13.811-30.846 30.846 0 17.036 13.811 30.846 30.846 30.846h628.36L583.084 746.147c-12.497 12.496-12.497 32.758 0 45.255 6.248 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.372l256.775-256.775a31.999 31.999 0 0 0 0-45.254z" p-id="4248"></path></svg>
                </div>
            ` : ''
            html += `
                <div class="swiper-slide announce-swiper-slide announce-swiper-slide-${index+1}" data-showcountdown="${item.show_count_down}" data-url="${item.link}" style="${style}"
                    data-params-type="${item.show_count_down == 'true' ? 'countdown' : 'text'}"
                    data-params-banner_name="${item.text}"
                    data-params-link="${item.link}"
                >
                    <div class="announce-item" >
                        <div class="announce-item-container" style="justify-content: ${item.content_position};">
                            ${textHtml}
                            <div class="countdown" style="display: ${item.show_count_down == 'true' ? 'flex' : 'none'}">
                                <div class="countdown-item">
                                  <span class="_days" style="background:  ${item.count_down_bg_color}; color: ${item.count_down_num_color}"></span>
                                   <i style="color:${item.count_down_text_color}">${item.days}</i>
                                </div>
                                <div class="countdown-item">
                                  <span class="_hours" style="background:  ${item.count_down_bg_color}; color: ${item.count_down_num_color}"></span>
                                    <i style="color:${item.count_down_text_color}">${item.hrs}</i>
                                </div>
                                <div class="countdown-item">
                                  <span class="_mins" style="background:  ${item.count_down_bg_color}; color: ${item.count_down_num_color}"></span>
                                   <i style="color:${item.count_down_text_color}">${item.mins}</i>
                                </div>
                                <div class="countdown-item">
                                  <span class="_secs" style="background:  ${item.count_down_bg_color}; color: ${item.count_down_num_color}"></span>
                                  <i style="color:${item.count_down_text_color}">${item.secs}</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `
          });
          this.selectors.announce_swiper_container.html(html)
          // 如果有多个则展示slide
          if (filterBars.length > 1) {
            new Swiper(".announce-bar-swiper", {
              loop: true,
              autoplay: {
                delay: that.speed * 1000 || 5000,
              },
              effect: "fade", // 淡入淡出
              fadeEffect: {
                crossFade: true,
              },
            });
          }
          filterBars.forEach((item, index) => {
            const els = document.querySelectorAll(`.announce-swiper-slide-${index+1} .countdown`)
            els.forEach(el => {
              countTime(new Date(item.end_time).getTime(), that.serverTime, el, function() {
                  el.remove();
              })
            })

        })
        }
        // Announcebar的事件监听
        async onAnnouncebar() {
          // 显示隐藏
          $("body").on("mouseenter", ".announce-swiper-slide", function (e) {
            const flag = $(this).data("showcountdown");
            if (flag === false) {
              $(this).find(".svg-arrow-line").fadeIn();
            }
          });
          $("body").on("mouseleave", ".announce-swiper-slide", function (e) {
            const flag = $(this).data("showcountdown");
            if (flag === false) {
              $(this).find(".svg-arrow-line").fadeOut();
            }
          });
          // slide点击跳转
          $("body").on("click", ".announce-swiper-slide", function (e) {
            const url = $(this).data("url");
            if (url) {
              window.dataLayer.push({ "event_parameters": null });
              window.dataLayer.push({
                event: "ga4Event",
                event_name: "top_tip_banner4.0",
                event_parameters:{
                  current_page: window.location.href,
                  type: $(this).data("params-type"),
                  banner_name: $(this).data("params-banner_name"),
                  link: $(this).data("params-link"),
                 }
              });
              window.open(url);
            }
          });
        }

        closeAnnouncebar() {
          // 通知栏关闭
          let that = this;
          this.selectors.announce_close.click(function () {
            that.selectors.announce_bar.slideToggle(250);
            window.sessionStorage.setItem("announce-bar", "true");
          });
        }

        async init() {
          let that = this
          loadCSS(pageInfo.__webpack_public_path__ + 'plugin-announcement-bar-new.min.css', () => {
            that.classList.remove("hidden");
          });

          const announceBarFlag = window.sessionStorage.getItem("announce-bar");
          if (announceBarFlag == "true") {
            return false;
          }
          await this.getTime()
          // 初始化通知栏
          this.initAnnouncebar();
          this.onAnnouncebar();
          this.closeAnnouncebar();
        }

      }
    );
  }
});
